/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class IntercomService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Intercom Token
     * @returns any Successful Response
     * @throws ApiError
     */
    public getIntercomToken(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/intercom/token',
        });
    }

}
